<template>
  <Wrapper>
    <CommonQuestion></CommonQuestion>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../components/pc/Wrapper";
import CommonQuestion from "../../../components/pc/faq/CommonQuestion";
export default {
  components: {
    Wrapper,
    CommonQuestion,
  },
  name: "Question",
};
</script>



// WEBPACK FOOTER //
// src/pages/pc/faq/Question.vue